export enum MicroAppCacheKey {
  /** 国际化 */
  I18nMapKey = 'D-I18nMap',

  /** Delivery 国际化 */
  DeliveryI18nMapKey = 'deliveryLocale',

  /** 用户详情 */
  UserInfoKey = 'D-UserInfo',

  /** 字典 */
  AllLookupItemKey = 'D-AllLookupItem',

  /** 时区 */
  UserTimeZone = 'UserTimeZone',

  /** 开发者模式 */
  DevelopModeKey = 'D-developMode'
}
